import React, { useState, useEffect } from 'react';
import { faqAPI } from '../services/api';
import './FAQ.css';

/**
 * SSS (Sıkça Sorulan Sorular) Sayfası
 * Karadaş Hukuk Bürosu
 *
 * Modern accordion yapısı ile interaktif soru-cevap listesi
 */

interface FAQItem {
  id: number;
  question: string;
  answer: string;
  category?: string;
  order_index?: number;
  created_at?: string;
  updated_at?: string;
}

const FAQ: React.FC = () => {
  const [faqData, setFaqData] = useState<FAQItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Backend'den SSS'leri al
  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        setLoading(true);
        const response = await faqAPI.getAll();
        if (response.data.success && response.data.faqs) {
          setFaqData(response.data.faqs);
        }
      } catch (err: any) {
        console.error('FAQ yükleme hatası:', err);
        setError('SSS\'ler yüklenirken bir hata oluştu.');
      } finally {
        setLoading(false);
      }
    };

    fetchFAQs();
  }, []);

  // Accordion state
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-page">
      {/* FAQ CONTENT */}
      <section className="faq-content-section">
        <div className="faq-container">
          {/* Page Title */}
          <h1 className="faq-title">SIKÇA SORULAN SORULAR</h1>

          {/* Loading State */}
          {loading && (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--text)' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px', color: 'var(--primary)' }}>
                <i className="bi bi-arrow-repeat" style={{ animation: 'spin 1s linear infinite' }}></i>
              </div>
              <p>SSS'ler yükleniyor...</p>
            </div>
          )}

          {/* Error State */}
          {error && !loading && (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--text)' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px', color: '#dc3545' }}>
                <i className="bi bi-exclamation-circle"></i>
              </div>
              <p>{error}</p>
            </div>
          )}

          {/* FAQ Accordion */}
          {!loading && !error && faqData.length > 0 && (
            <div className="faq-accordion-wrapper">
              {faqData.map((faq, index) => (
              <div key={faq.id} className="faq-item">
                {/* Question Button */}
                <button
                  className={`faq-question ${openIndex === index ? 'active' : ''}`}
                  onClick={() => toggleAccordion(index)}
                  aria-expanded={openIndex === index}
                >
                  <span className="faq-question-text">{faq.question}</span>
                  <i
                    className={`bi bi-chevron-down faq-icon ${
                      openIndex === index ? 'rotate' : ''
                    }`}
                  ></i>
                </button>

                {/* Answer Content */}
                <div className={`faq-answer ${openIndex === index ? 'show' : ''}`}>
                  <div className="faq-answer-content">
                    <p>{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
            </div>
          )}

          {/* Empty State */}
          {!loading && !error && faqData.length === 0 && (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--text)' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px', color: 'var(--primary)', opacity: 0.5 }}>
                <i className="bi bi-inbox"></i>
              </div>
              <h3 style={{ fontSize: '24px', marginBottom: '12px' }}>Henüz SSS Bulunmuyor</h3>
              <p style={{ color: 'var(--secondary)' }}>Yakında eklenecek sorular için bizi takip edin.</p>
            </div>
          )}

          {/* CTA Box */}
          {!loading && (
          <div className="faq-cta-box">
            <div className="faq-cta-icon">
              <i className="bi bi-question-circle"></i>
            </div>
            <div className="faq-cta-content">
              <h3>Sorunuzun cevabını bulamadınız mı?</h3>
              <p>
                Size yardımcı olmaktan mutluluk duyarız. Bizimle iletişime geçin, tüm
                sorularınızı yanıtlayalım.
              </p>
            </div>
            <a href="mailto:info@karadashukuk.com" className="faq-cta-button">
              <i className="bi bi-envelope"></i>
              İletişime Geçin
            </a>
          </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default FAQ;
